import classnames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DownloadIcon from '@material-symbols/svg-300/rounded/download.svg'

import { Certificate } from '../../../models/Certificate'
import certificateValidity from '../../../state/calculations/certificateValidity'

import styles from './CertificateSlug.module.scss'

export default React.memo(function CertificateSlug({ certificate }: { certificate: Certificate }) {
  const { t } = useTranslation()

  const { validity } = certificateValidity(certificate.validUntil)

  return (
    <span className={classnames(styles.CertificateSlug, styles[validity])}>
      {certificate.certificateId && (
        <span className={styles.certificateId}>
          {t('certificate.certificate id is <id>', { id: certificate.certificateId.substring(0, 22) + '…' })}
        </span>
      )}

      {certificate.certificateUrl && (
        <span>
          <a target="_blank" href={certificate.certificateUrl} aria-label={t('certificate.download certificate')}>
            <DownloadIcon />
          </a>
        </span>
      )}
    </span>
  )
})
